import { Box } from "@chakra-ui/react";
import { useTab } from "../../contexts/useTab";
import TableEmployeeStopWorking from "./tableEmployeeStopWorking";

export default function EmployeeStopWorking() {
 
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <TableEmployeeStopWorking />
    </Box>
  );
}
